import { ApiTablePage } from 'components/ApiTablePage/ApiTablePage';
import { memo } from 'react';
import type { FC } from 'react';
import { useTableEndpoint } from 'utils/table/useTableEndpoint';

export const connectivityErrorsApiEndpoint =
  '/tables/management/connectivity-errors';

const BareConnectivityErrorsPage: FC = () => {
  const endpoint = useTableEndpoint({
    apiEndpoint: connectivityErrorsApiEndpoint,
  });

  return (
    <div className='m bg-default rounded flex flex-col flex-1'>
      <ApiTablePage endpoint={endpoint} tableClassName='rounded' />
    </div>
  );
};

export const ConnectivityErrorsPage = memo(BareConnectivityErrorsPage);
